/*
---
name: Remote
description: Provides default JSON rpc request functionality
authors:
- David Chan CK (http://www.reol.com)
license:
- MIT-style license
requires:
- core/1.2.4: '*'
provides: [Remote]
...
*/
var Remote = new Class
({
	Implements: [Events, Options],
	options:
	{
		rpc_path: '',
		data: '',
		rpc: null,
		extra_query_string: null,
		autostart: true,
		method: 'post' // by default use post...
	},
	initialize: function(options)
	{
		this.setOptions(options);
		this.build();
		return;
	},
	build: function()
	{
		this.data;
		this.has_data = false;
		this.rpc_count = 0;
		this.rpc_url;
		this.rqt;
		this.statement;

		this.prepare();
		if (this.options.autostart)
		{
			this.send();
		}
		return;
	},
	prepare: function(new_qs)
	{
		var opts = this.options,
				qs = (new_qs) ? new_qs : opts.extra_query_string,
				qs = (qs) ? qs+'&' : '',
				rq,
				rpc_qs_token = '?';

		if(opts.rpc.contains('?')){
			rpc_qs_token = '&';
		}
		this.qs = qs+'rpc_count='+(++this.rpc_count);
		this.statement = opts.rpc_path+opts.rpc+rpc_qs_token+this.qs;
		return this;
	},
	send: function()
	{
		if(this.rqt != null){
			this.rqt.cancel();
		}

		this.rqt = new Request.JSON({
			data: this.qs + this.options.data,
			url: this.statement,
			noCache: true,
			onSuccess: function(data){
				this.has_data = true;
				this.set_data(data);
				this.fireEvent('onSuccess');
			}.bind(this)
		});

		if (this.options.method === 'get') {
			this.rqt.get();
		} else {
			this.rqt.post();
		}

		return;
	},
	cancel: function(){
		if(this.rqt){
			this.rqt.cancel();
		}
	},
	get_data: function()
	{
		return (this.has_data) ? this.data : false;
	},
	get_rpc: function()
	{
		return this.rpc;
	},
	set_data: function(data)
	{
		if (data instanceof Object)
		{
			//Log.log('Remote data is set: ');
			//Log.log(data);
			this.data = data;
		}
		else
		{
			Log.log('RPC: '+this.options.rpc+'. Invalid data');
		}
	}
});
